export const HARD_SIGN_OUT_EVENT = "salesably:hard-signout";

export function hardSignOut(callbackUrl = "/") {
  if (typeof window === "undefined") return;

  try {
    window.dispatchEvent?.(new Event(HARD_SIGN_OUT_EVENT));
  } catch {
    // Sign-out must proceed even if a test shim or unusual browser blocks the event.
  }

  const signOutUrl = new URL("/api/auth/hard-signout", window.location.origin);
  signOutUrl.searchParams.set("callbackUrl", callbackUrl);
  window.location.assign(signOutUrl.toString());
}
